import { render, staticRenderFns } from "./YatirimciTanimla.vue?vue&type=template&id=1ebd97b5&scoped=true&"
import script from "./YatirimciTanimla.vue?vue&type=script&lang=js&"
export * from "./YatirimciTanimla.vue?vue&type=script&lang=js&"
import style0 from "./YatirimciTanimla.vue?vue&type=style&index=0&id=1ebd97b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebd97b5",
  null
  
)

export default component.exports